export const keys = {
  google_client_id:
    // "529497943622-p0h0okokire5thl8orttv4ptu1bhu349.apps.googleusercontent.com",
    "529497943622-qhtuhv4t6td7erbgvdrjv2fch341ujec.apps.googleusercontent.com",
  // facebook_api_id: "483515579898996",
  facebook_api_id: "1373114076161386",
  google_api_key: "AIzaSyCqZEpdBk5ErumVxJIJBbC20_XhqLZedtM",
  // google_api_key: "AIzaSyBVZWqrwReCJ-G3xy0iKRoWmfUxaxE_aAE",
};
